import { Grid } from '@mui/material';

import { Project } from '../../../../domain/project/Project';
import { CustomersAdditionalInfo } from './CustomersAdditionalInfo';
import { CustomersAppActions } from './CustomersAppActions';
import { CustomersAppMonitor } from './CustomersAppMonitor';
import { CustomersPIN } from './CustomersPIN';
import { CustomersStopCanceledFields } from './CustomersStopCanceledFields';
import { CustomersStopCompletedFields } from './CustomersStopCompletedFields';
import { CustomersStopFields } from './CustomersStopFields';
import { CustomersSurvey } from './CustomersSurvey';

interface CustomersAppOptionsProps {
  project: Project;
}

export const CustomersAppOptions = ({ project }: CustomersAppOptionsProps) => {
  return (
    <Grid container direction="column" wrap="nowrap" style={{ minHeight: `calc(100vh - 118px)` }}>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersAppMonitor project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersStopFields project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersPIN project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersAppActions project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersAdditionalInfo project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersSurvey project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersStopCompletedFields project={project} />
      </Grid>
      <Grid item style={{ marginTop: `-1px` }}>
        <CustomersStopCanceledFields project={project} />
      </Grid>
    </Grid>
  );
};
